import currencyFormatter from 'currency-formatter';
import { Typography } from 'material-ui';
import { withStyles } from 'material-ui/styles';
import React from 'react';
import { translate } from 'react-i18next';

const styles = theme => ({
    price: {
        marginTop: '0px',
        marginBottom: '4px',
        fontWeight: 700,
        fontSize: '1.5em',
        color: 'var(--error-color)',
        textAlign: 'right'
    }
});

class PriceTag extends React.Component {


    formatPrice(value) {
        return currencyFormatter.format(value, { code: 'EUR' });
    }


    render() {
        const { B2bVerPVP, pvp, price, showNetPrice, classes, t } = this.props;
        let priceTooltip = '';

        if (showNetPrice) {
            priceTooltip = t('BOOKINGS.NET') + ': ' + this.formatPrice(price);
        }

        return B2bVerPVP ?
            (
                <Typography className={classes.price}>
                    {
                        <span title={priceTooltip}>
                            {this.formatPrice(pvp)}
                        </span>
                    }
                </Typography>
            )
            :
            (
                <Typography className={classes.price}>
                    {this.formatPrice(price)}
                </Typography>
            );
    }
}

export default translate('translations')(withStyles(styles)(PriceTag));


// WEBPACK FOOTER //
// ./src/components/Results/PriceTag.js